module.exports = __webpack_public_path__ + "static/img/2areaA_28.83a35d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_28.png
// module id = 903
// module chunks = 1